function Line({ subtitle, details, children, styles }) {
  return (
    <div className={styles.line}>
      <h2 className={styles.subtitle}>
        {subtitle}
        {details && <span>&nbsp;{details}</span>}
      </h2>
      <div>{children}</div>
    </div>
  );
}

export default Line;